import React from 'react';
import {useParams, Link} from 'react-router-dom';
import {Box, Chip, Stack, Typography, Button, Card, CardHeader} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Constants from '../../utils/constants.js';
import Loader from './layout/loading/loader.js';
import PhotoCarousel from './layout/PhotoCarousel.js';
import {useGetInterventionDetailQuery} from '../../modules/graffiti/graffiti.api.js';
import {helper} from '../../utils/helper.js';
import {ConteneurIcon} from "../../utils/ui/Icons/ConteneurIcon.js";

export default function GraffitiInterventionDetailPage() {
	const {id} = useParams();
	const {data, isFetching, isLoading, isError} = useGetInterventionDetailQuery({id});

	const loading = isFetching || isLoading;

	// Champs attendus (avec fallback pour différentes conventions back)
	const date = helper.getFormattedDatetime(
	  data?.dateEvenement || data?.date_evenement || data?.date || data?.createdAt
	);
	const rue = data?.rue?.nom || data?.rue || data?.adresse || '';
	const methode = data?.methode || data?.method || '';
	const surface = typeof data?.surfaceM2 !== 'undefined' ? data.surfaceM2 : (data?.surface_m2 ?? data?.surface);
	const coffret = data?.coffret ?? null;

	const photosAvant = data?.photosAvant || data?.photos_avant || [];
	const photosApres = data?.photosApres || data?.photos_apres || [];
	const hasPhotos = (Array.isArray(photosAvant) && photosAvant.length > 0) ||
	  (Array.isArray(photosApres) && photosApres.length > 0);

	return (
	  <Box>
		  <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 3}}>
			  <Button component={Link} to={-1} startIcon={<ArrowBackIcon/>}>
				  Retour
			  </Button>
			  <Typography variant="h6">Détail intervention graffiti</Typography>
		  </Stack>

		  {loading && <Loader/>}
		  {isError && (
			<Typography color="error" variant="body2">Erreur lors du chargement de l'intervention.</Typography>
		  )}

		  {!loading && !isError && (
			<Stack spacing={4} sx={{mt: 4}}>
				<Card>
					<CardHeader
					  title={date + " - " + rue}
					  subheader={
						  <>
							  <Box display="flex" alignItems="center" gap={1} mb={2} mt={2}>
								  <Chip
									size='small'
									label={`Méthode : ${methode}`}
								  />
								  <Chip
									size='small'
									label={`Surface : ${surface} m²`}/>
								  {coffret && (
									<Chip
									  size='small'
									  icon={<ConteneurIcon/>}
									  label={`Coffret : ${String(coffret)}`}
									/>
								  )}
							  </Box>
						  </>
					  }/>
				</Card>


				{/* Photos avant/après - style InterventionView */}
				{hasPhotos && (
				  <Stack direction="row" spacing={2} alignItems="stretch">
					  {Array.isArray(photosAvant) && photosAvant.length > 0 && (
						<Box flexGrow={1}>
							<PhotoCarousel
							  photoArray={photosAvant}
							  label="Photos avant"
							  headerStyle="carousel-blue"
							  assetsUrl={`${Constants.API_ASSETS_PHOTO_INTERVENTION}/`}
							/>
						</Box>
					  )}
					  {Array.isArray(photosApres) && photosApres.length > 0 && (
						<Box flexGrow={1}>
							<PhotoCarousel
							  photoArray={photosApres}
							  label="Photos après"
							  headerStyle="carousel-green"
							  assetsUrl={`${Constants.API_ASSETS_PHOTO_INTERVENTION}/`}
							/>
						</Box>
					  )}
				  </Stack>
				)}
			</Stack>
		  )}
	  </Box>
	);
}
